import { createSlice } from "@reduxjs/toolkit";

const initialValue = {
    unreadCount: 0
}

export const notificationSlice = createSlice({
    name: 'notification',
    initialState: initialValue,
    reducers: {
        setUnreadCount: (state, action) => {
            state.unreadCount = action.payload;
        },
        decrementUnread: (state) => {
            if (state.unreadCount > 0) {
                state.unreadCount -= 1;
            }
        },
        resetUnread: (state) => {
            state.unreadCount = 0;
        }
    }
})

export const { setUnreadCount, decrementUnread, resetUnread } = notificationSlice.actions
export default notificationSlice.reducer
